import {PATH_GROUPS} from "@constants/navigate";
import {IBreadcrumbItem} from "@ui/breadcrumbCustom/types";

export const BREADCRUMBS_GROUPS: IBreadcrumbItem[] = [
    {
        label: 'base.groups', path: PATH_GROUPS
    },
]